import { Redirect, Route, Switch } from "react-router-dom";
import CaseManagementPage from "pages/CaseManagementPage";
import CasePage from "pages/CasePage";

export const CaseManagementRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route
        exact
        path="/pages/case-management"
        component={CaseManagementPage}
      />
      <Route exact path="/pages/case-management/:caseid" component={CasePage} />

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect
        path="/pages/case-management/:caseid"
        to="/pages/case-management/:caseid"
      />
      <Redirect to="/pages/case-management" from="/pages/case-management" />
      <Redirect to="/pages" />
    </Switch>
  );
};
